import { VariantProps } from "class-variance-authority";

import { buttonVariants } from "../ui/button";

export enum ConfirmationModalVariant {
  default = "default",
  warning = "warning",
  destructive = "destructive",
}

export interface ConfirmationModalProps {
  title: string | React.ReactNode;
  isNavigationBlocked?: boolean;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  leaveButtonText: string;
  saveButtonText: string;
  handleOnConfirm: (nextLocationFullPath?: string, proceedWithNavigation?: () => void) => void;
  handleLeave?: () => void;
  handleClose?: () => void;
  description?: string;
  MarkdownDescription?: React.ReactNode;
  isLoading?: boolean;
  exitButtonVariant?: VariantProps<typeof buttonVariants>["variant"];
  saveButtonVariant?: VariantProps<typeof buttonVariants>["variant"];
  headerVariant?: ConfirmationModalVariant;
  children?: React.ReactNode;
  useBlocker?: boolean;
  requireConfirmation?: boolean;
  confirmationText?: string;
  confirmationPlaceholder?: string;
  contentClassName?: string;
  overlayClassName?: string;
}

export interface Location {
  pathname: string;
  search?: string;
  hash?: string;
}

export interface Transition {
  currentLocation: Location;
  nextLocation: Location;
}
